import { Box, Stack, Typography, IconButton, Button } from "@mui/material";
import { JobBoard } from "@store/jobBoards/jobBoards.model";
import { useState } from "react";
import { jobBoardsService } from "@store/jobBoards/jobBoards.service";
import ModalComponent from "@components/modal/Modal.component";
import { useTranslation } from "react-i18next";

interface Props {
  jobBoard: JobBoard;
}

const JobBoardWithoutStripeCard = ({ jobBoard }: Props) => {
  const { t } = useTranslation();

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const handleDelete = () => {
    jobBoardsService.deleteJobBoardWithoutStripe(jobBoard.id).subscribe({
      next: () => {
        setOpenConfirmDialog(false);
        jobBoardsService.getJobBoards().subscribe();
      },
      error: (error) => {
        console.error("Erreur lors de la suppression:", error);
      },
    });
  };

  return (
    <Box
      sx={{
        backgroundColor: "white",
        borderRadius: "16px",
        padding: "20px",
        height: "100%",
        position: "relative",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.05)",
        transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.1)",
        },
      }}>
      <Stack direction="row" spacing={2} alignItems="center">
        <Box
          sx={{
            width: "60px",
            height: "60px",
            borderRadius: "12px",
            backgroundColor: "#f8f9fa",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
          {jobBoard.picture ? (
            <img
              src={jobBoard.picture}
              alt={jobBoard.name}
              style={{
                width: "40px",
                height: "40px",
                objectFit: "contain",
              }}
            />
          ) : (
            <Box
              sx={{
                width: "40px",
                height: "40px",
                borderRadius: "8px",
                backgroundColor: "#e9ecef",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "16px",
                fontWeight: "400",
              }}>
              {jobBoard.name.charAt(0)}
            </Box>
          )}
        </Box>
        <Stack>
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: "600",
            }}>
            {jobBoard.name}
          </Typography>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "400",
            }}>
            {jobBoard.type}
          </Typography>
        </Stack>
        <IconButton onClick={() => setOpenConfirmDialog(true)}>
          <img src="/images/icon_delete.svg" alt="delete" />
        </IconButton>
      </Stack>

      {openConfirmDialog && (
        <ModalComponent
          title={t("adminParameters.jobboardWithoutStripe.delete.title")}
          content={<Typography sx={{ marginTop: "20px", textAlign: "center" }}> {t("adminParameters.jobboardWithoutStripe.delete.description", { name: jobBoard.name })}</Typography>}
          actions={
            <>
              <Button onClick={() => setOpenConfirmDialog(false)}>{t("adminParameters.jobboardWithoutStripe.delete.cancel")}</Button>
              <Button onClick={handleDelete} color="error" variant="contained">
                {t("adminParameters.jobboardWithoutStripe.delete.delete")}
              </Button>
            </>
          }
          handleClose={() => setOpenConfirmDialog(false)}
          maxWidth="sm"
        />
      )}
    </Box>
  );
};

export default JobBoardWithoutStripeCard;
